<template>
  <div class="footerBottom">
    <div class="links" :class="{ active: isActive }">
      <p><span class="current">友情链接</span></p>
      <!-- <ul class="clearfix">
        <li v-for="(val, key) in linkList" class="fl" :key="key">
          <a :href="val.templateContent">{{ val.templateName }}</a>
        </li>
      </ul> -->
      <span class="expansion" v-show="isActive" @click="isActive = false"
        >展开<i class="el-icon-arrow-down"></i
      ></span>
      <span class="expansion" v-show="!isActive" @click="isActive = true"
        >收起<i class="el-icon-arrow-up"></i
      ></span>
    </div>
    <div class="footer_top">
      <router-link target="_blank" :to="{ path: '/aboutUs' }"
        >关于我们</router-link
      >|
      <router-link target="_blank" :to="{ path: '/contactUs' }"
        >联系我们</router-link
      >|
      <router-link target="_blank" :to="{ path: '/recruitment' }"
        >人才招聘</router-link
      >|
      <router-link target="_blank" :to="{ path: '/advertisingServices' }"
        >广告服务</router-link
      >|
      <router-link target="_blank" :to="{ path: '/disclaimer' }"
        >免责声明</router-link
      >
    </div>
    <div class="footer_new">
      <div class="new_content clearfix">
        <div class="new_left fl">
          <p>
            <router-link :to="{ path: '/index' }"
              ><img
                style="width: 255px; margin-left: -20px"
                src="@/assets/imgs/logo1.png"
                alt="logo"
            /></router-link>
          </p>
          <p class="tel">联系电话：<i>021-50829828</i></p>
          <p class="qq">
            QQ咨询：
            <a
              href="http://wpa.qq.com/msgrd?v=3&uin=421555737&site=qq&menu=yes"
              target="_blank"
              rel=”nofollow”
            >
              <i class="icon iconfont" style="color: #fff; margin-right: 4px"
                >&#xe63d;</i
              >QQ咨询
            </a>
          </p>
        </div>
        <div class="new_center fl clearfix">
          <div class="copyright_C_list">
            <p>关于我们</p>
            <div class="about">
              <router-link target="_blank" :to="{ path: '/aboutUs' }"
                >关于我们</router-link
              >
            </div>
            <div class="about">
              <router-link target="_blank" :to="{ path: '/contactUs' }"
                >联系我们</router-link
              >
            </div>
          </div>
          <div class="copyright_C_list">
            <p>产品服务</p>
            <div class="about">
              <router-link target="_blank" :to="{ path: '/recruitment' }"
                >人才招聘</router-link
              >
            </div>
            <div class="about">
              <router-link
                target="_blank"
                :to="{ path: '/advertisingServices' }"
                >广告服务</router-link
              >
            </div>
          </div>
          <div class="copyright_C_list">
            <p>免责声明</p>
            <div class="about">
              <router-link target="_blank" :to="{ path: '/disclaimer' }"
                >免责声明</router-link
              >
            </div>
          </div>
        </div>
        <div class="new_right fr">
          <div class="copyright_R">
            <span><img src="~@/assets/imgs/微1.png" /></span>
            <p>下载硕博同城-安卓端</p>
          </div>
        </div>
        <div class="new_right fr">
          <div class="copyright_R">
            <span><img src="~@/assets/imgs/微信图片_20230901145218.png" /></span>
            <p>下载硕博同城-IOS端</p>
          </div>
        </div>
        <div class="new_right fr">
          <div class="copyright_R">
            <span><img src="~@/assets/imgs/WechatIMG.jpeg" /></span>
            <p>扫描关注微信公众号</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer_bottom">
      <div class="footer_content">
        <p class="">
          Copyright &copy; 科研人才网 版权所有 网站备案信息：<a
            target="_blank"
            href="http://www.beian.miit.gov.cn"
            >沪ICP备19004410号-2</a
          >
        </p>
        <!-- <p class="fr">Copyright &copy; 科研人才网 版权所有 网站备案信息：沪ICP备19004410号-2</p> -->
      </div>
    </div>
  </div>
</template>
<script>
import { get, postWithJson, form } from "@/api/services";
(function () {
  var bp = document.createElement("script");
  var curProtocol = window.location.protocol.split(":")[0];
  if (curProtocol === "https") {
    bp.src = "https://zz.bdstatic.com/linksubmit/push.js";
  } else {
    bp.src = "http://push.zhanzhang.baidu.com/push.js";
  }
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(bp, s);
})();
export default {
  name: "footers",
  data() {
    return {
      resData: "",
      linkList: "",
      isActive: true,
    };
  },
  created: function () {
    this.search();
  },
  methods: {
    search() {
      // 搜索
      let _self = this;

      postWithJson("front/url/list").then(
        function (response) {
          if (response.data.status) {
            if (response.data.data) {
              _self.linkList = response.data.data;
            }
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: response.data.message,
            type: "error",
          });
        }
      );
    },
  },
};
</script>
<style scoped = "scoped"  lang = "less">
.footerBottom {
  background-color: #666;
  .active {
    height: 117px;
    overflow: hidden;
  }
  .links {
    width: 980px;
    margin: 0 auto;
    position: relative;
    p {
      border-bottom: 1px solid #e8e8e8;
      font-size: 16px;
      color: #fdfdfd;
      margin-bottom: 21px;
      .current {
        display: inline-block;
        padding: 14px 0;
        border-bottom: 2px solid #fdfdfd;
      }
    }
    ul {
      display: inline-block;
      width: 900px;
    }
    li {
      white-space: nowrap;
      padding: 8px 18px 8px 0;
      color: #555;
      text-decoration: none;
      a {
        color: #ccc;
        font-size: 14px;
      }
    }
    li:hover {
      a {
        color: #fff;
      }
    }
    .expansion {
      height: 22px;
      position: absolute;
      right: 3px;
      top: 78px;
      cursor: pointer;
      color: #ccc;
      font-size: 14px;
      vertical-align: middle;
      i {
        font-size: 18px;
        font-weight: bold;
        vertical-align: middle;
        margin-left: 4px;
        margin-top: -4px;
      }
    }
  }
  .footer_top {
    text-align: center;
    background-color: #4e4e4e;
    color: #8f8f8f;
    height: 50px;
    line-height: 50px;
    vertical-align: middle;
    display: none;
    a {
      color: #8f8f8f;
      margin: 0 10px;
      font-size: 12px;
      vertical-align: middle;
    }
  }
  .footer_new {
    /* background-color: white; */
    background-color: #4e4e4e;
    /* padding: 20px 0; */

    .new_content {
      /* border-bottom: 1px solid #ededed; */
      width: 1150px;
      margin: 0 auto;
      padding: 20px 0;
      color: #fff;
      .tel {
        height: 40px;
        line-height: 40px;
        /* margin-top: 10px; */
        i {
          font-style: normal;
          font-size: 24px;
          color: #f90;
        }
      }
      .qq {
        margin-top: 10px;
        a {
          display: inline-block;
          background-color: #1787fb;
          padding: 6px 10px;
          color: #fff;
        }
      }
      .new_center {
        padding-left: 150px;
        .copyright_C_list {
          float: left;
          padding-top: 24px;
          p {
            display: block;
            font-size: 18px;
            color: rgb(221, 215, 215);
            padding-bottom: 28px;
          }
          .about {
            overflow: hidden;
            margin-bottom: 22px;
            a {
              display: block;
              font-size: 12px;
              color: rgb(243, 242, 242);
              float: left;
              margin-right: 24px;
            }
            a:hover {
              text-decoration: underline;
            }
          }
        }
        .copyright_C_list:nth-child(2) {
          margin-left: 54px;
          margin-right: 54px;
        }
      }
      .new_right {
        text-align: center;
        /* padding-right: 20px; */
        span {
          display: block;
          width: 120px;
          height: 120px;
          border: 1px solid #ededed;
          padding: 10px;
        }
        img {
          width: 100px;
        }
        p {
          display: block;
          font-size: 12px;
          color: #999;
          text-align: center;
          padding-top: 6px;
          text-align: center;
        }
      }
    }
  }
  /* .footer_bottom{
            text-align: center;
            background-color: #fff;
            color: #666;
            height: 60px;
            padding-top: 18px;
            font-weight:400;
            font-family:PingFangSC-Regular;
            font-size:12px;
            .footer_content{
                width: 1200px;
                margin: 0 auto;
            }
            p{
                line-height:22px
            }
        } */
  .footer_bottom {
    text-align: center;
    background-color: #303030;
    color: #8f8f8f;
    height: 60px;
    padding-top: 18px;
    font-weight: 400;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    p {
      line-height: 22px;
      a {
        color: #8f8f8f;
      }
    }
  }
}
@media all and (max-width: 768px) {
  .footerBottom .links {
    display: none;
  }
  .footerBottom .footer_top a {
    margin: 0 6px;
  }
  .footer_new {
    display: none;
  }
  .footer_top {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue